module.exports = __webpack_public_path__ + "1a1c345c164ab3bcaa529ace84bb5bda.png";